﻿// custom DOB validator
window.Parsley
    .addValidator('datedob', {
        requirementType: 'string',
        validateDate: function (value, requirement) {
            var startDate = new Date();
            startDate.setYear(startDate.getFullYear() - 1);
            var date = new Date(value);
            return date < startDate;
        },
        messages: {
            en: 'Please check your date of birth'
        }
    });
// https://developers.google.com/recaptcha/docs/loading
if (typeof grecaptcha === 'undefined') {
    console.log("Initialising empty grecaptcha");
    grecaptcha = {};

    grecaptcha.ready = function (cb) {
        if (typeof grecaptcha === 'undefined') {
            // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
            // configuration. By default, any functions listed in its 'fns' property
            // are automatically executed when reCAPTCHA loads.
            const c = '___grecaptcha_cfg';
            window[c] = window[c] || {};
            (window[c]['fns'] = window[c]['fns'] || []).push(cb);
        } else {
            cb();
        }
    }
}

var forms = (function () {
    return {
        renderCaptcha: function (q, callback) {
            grecaptcha.ready(function () {
                console.log("greCAPTCHA ready!!");
                var htmlEl = document.querySelector(q);
                function doCallback(response) {
                    console.log("doCallback", response);
                    grecaptcha.execute().then(callback);
                }
                recaptchaId = grecaptcha.render(htmlEl, {
                    sitekey: '6Ldowt4lAAAAAD0EOLfmKwkdAVa0EkrkTY2ZHXPB',
                    size: 'invisible',
                    callback: doCallback
                }, false);
            });
        },
        hookAjaxForm: function (formId, apiEndpoint, updateDiv, loaderDiv, successCallback, hasCaptcha) {
            //replaces broken Ajax.BeginForm - we don't care about falling back to no JS
            var form = $(formId);
            var hasCap = typeof hasCaptcha !== 'undefined' && hasCaptcha;

            function validateAndPost() {
                if ($(formId).parsley().validate()) { // .isValid()??
                    if (hasCap && typeof (grecaptcha) !== 'undefined') {
                        var capres = grecaptcha.getResponse();
                        if (capres == '') {
                            console.log("No reCaptcha");
                            grecaptcha.execute();
                            return false;
                        }
                    }
                    if (loaderDiv !== 'undefined') {
                        $(updateDiv).hide();
                        $(loaderDiv).show();
                    } 
                    var fd = new FormData(form[0]);
                    $.ajax({
                        url: apiEndpoint,
                        data: fd,
                        headers: { '__RequestVerificationToken': fd.get("__RequestVerificationToken") },
                        cache: false,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function (dataofconfirm) {
                            $(updateDiv).html(dataofconfirm);
                            if (loaderDiv !== 'undefined') {
                                $(loaderDiv).hide();
                                $(updateDiv).show();
                            }
                            $(formId).show();
                            if (typeof successCallback === 'function') {
                                successCallback();
                            }
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            console.log("!!Error fired!!", xhr);
                            if (loaderDiv !== 'undefined') {
                                $(loaderDiv).hide();
                                $(updateDiv).show();
                            }
                            if (hasCap) {
                                grecaptcha.reset();
                            }
                            if (xhr.status == 404) {
                                console.log(data);
                            }
                            if (xhr.status == 403) {
                                console.log("403");
                            }
                        }
                    });
                }
            }
            // element to "render" invisible captcha in
            if (hasCap) {
                this.renderCaptcha('#js-captcha', function () {
                    console.log("renderCaptcha done");
                    validateAndPost();
                });
            }
            // ensure event is only hooked once
            form.off('submit').on('submit', function (e) {
                e.preventDefault();
                validateAndPost();
            });
        },
        init: function (setHeight) {
            var panel;
            $('.panel-heading span.clickable').on('click', function (el) {
                if ($(this).hasClass('panel-collapsed')) {
                    // expand the panel
                    $(this).parents('.panel').find('.panel-body').slideDown();
                    $(this).removeClass('panel-collapsed');
                    $(this).find('i').removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
                } else {
                    // collapse the panel
                    $(this).parents('.panel').find('.panel-body').slideUp();
                    $(this).addClass('panel-collapsed');
                    $(this).find('i').removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
                }
                return false;
            });
            $('#cancelBtn').on('click', function (el) {
                $('#mainform').parsley().reset();
                if (panel.hasClass("visible")) {
                    panel.removeClass('visible').animate({ 'margin-right': '-40%' });
                }
                return false;
            });
        },
        initForgotten: function () {
            //submitForgotten
            $('#submitForgotten').on('click', function () {
                return $('#retrieve').parsley().validate();
            });
        },
        initShowPassword: function () {
            $(document).on('mousedown', '.js-password-toggle', function () {
                $(this).closest('.input-group').find('input').attr('type', 'text');
            }).on('mouseup', '.js-password-toggle', function () {
                $(this).closest('.input-group').find('input').attr('type', 'password');
            });
        },
        initQuickReg: function (tb, btn, doNag) {
            // Show/hide password toggle
            forms.initShowPassword();
            tb.on('keyup', function (e) {
                if (e.keyCode == 13) {
                    btn.click();
                    return false;
                }
            });
        },
        initCorporate: function () {
            var cfg = {
                excluded: 'input[type=button], input[type=submit], input[type=reset]',
                inputs: 'input, textarea, select, input[type=hidden], :hidden',
            };
            $('#mainform').parsley(cfg);
            $('#email').on('blur', function () {
                $('#email').parsley(cfg).validate();
            });

            $('.js-submit').on('click', function (e) {
                e.preventDefault();
                if ($('#mainform').parsley(cfg).validate()) {
                    if (typeof (grecaptcha) !== 'undefined') {
                        var capres = grecaptcha.getResponse();
                        console.log("capres", capres);
                        if (capres == '') {
                            grecaptcha.execute();
                            return false;
                        }
                    }
                    $('#mainform').trigger('submit');
                }
            });
            forms.hookAjaxForm('#mainform',
                "/api/sitecore/CallRegistration/GetContent?Length=16",
                '#callRegDiv',
                '#Loading',
                null,
                true);
        },
        showSpinner: function () {
            $('#ftrModal .js-spinner').show();
        },
        hideSpinner: function () {
            $('#ftrModal .js-spinner').hide();
        },
        initEditCustom: function () {
            $('#mainform_details').parsley().subscribe('parsley:form:validate', function (formInstance) {
                // If any of these fields are valid
                if ($("input[id=tbHomeNumber]").parsley().isValid() ||
                    $("input[id=tbtMobNumber]").parsley().isValid() ||
                    $("input[id=tbWorkNumber]").parsley().isValid()) {
                    // Remove the error message
                    $('.invalid-form-error-message').html('');
                    // Remove the required validation from all of them, so the form gets submitted
                    // We already validated each field, so one is filled.
                    $("input[id=tbHomeNumber]").removeAttr('required').parsley().destroy();
                    $("input[id=tbtMobNumber]").removeAttr('required').parsley().destroy();
                    $("input[id=tbWorkNumber]").removeAttr('required').parsley().destroy();
                    return;
                }
                // If none is valid, add the validation to them all
                $("input[id=tbHomeNumber]").attr('required', 'required').parsley();
                $("input[id=tbtMobNumber]").attr('required', 'required').parsley();
                $("input[id=tbWorkNumber]").attr('required', 'required').parsley();
                // stop form submission
                formInstance.submitEvent.preventDefault();
                // and display a gentle message
                $('.invalid-form-error-message')
                    .html("Please supply at least one valid contact phone number")
                    .addClass("filled");
                return;
            });
        },
        initEditDetails: function () {
            //PCA support...
            var fields = [
                { element: "searchAddress", field: "search" },
                { element: "tbAddress1", field: "Line1", mode: pca.fieldMode.POPULATE },
                { element: "tbAddress2", field: "Line2", mode: pca.fieldMode.POPULATE },
                { element: "tbCity", field: "City", mode: pca.fieldMode.POPULATE },
                { element: "tbCounty", field: "Province", mode: pca.fieldMode.POPULATE },
                { element: "tbPostcode", field: "PostalCode" },
                { element: "tbCountry", field: "CountryName", mode: pca.fieldMode.COUNTRY }
            ],
                options = { key: "gt99-cx95-xg86-af93", setCountryByIP: true, autoSearch: true },
                control = new pca.Address(fields, options);
            control.listen("populate", function (address, variations) {
                pca.setValue('fullAddress', pca.tidy(address.Label, '\n'));
                // check we have the full address (required postcode in UK, requires line 1 and country for outside)
                var isuk = $('#tbCountry').val().toLowerCase() == "united kingdom",
                    hasL1 = $('#tbAddress1').val().length > 0,
                    has = (isuk && hasL1 && $('#tbPostcode').val().length > 0) || (!isuk && hasL1 && $('#tbCountry').val().length > 0);
                if (has) {
                    $('#hiddenHasAddress').val('true');
                    $('#btChangeAddress').val("Change your address");
                } else {
                    $('#hiddenHasAddress').val('');
                    $('#btChangeAddress').val("Add your address");
                }
                $('#hiddenHasAddress').parsley().validate(); // force refresh of validator
                $('#hiddenHasChangedAddress').val('true');
                $('#searchfields').hide();
                $('#fullAddress').fadeTo(600, 0.5, function () { $('#fullAddress').fadeTo(400, 1); });
            });
            $('#btChangeAddress').on('click', function () {
                $('#searchfields').show();
                return false;
            });
            //standard
            forms.initEditCustom();
            // hide the error summary
            $('#TopErrorHighlight').hide()
            // find the email field
            var emailField = $('#tbEmail');
            $('#emailAvailable').hide();
            // on email field blur...S
            emailField.blur(function () {
                $('#emailAvailable').hide();
                $.ajax({
                    type: "GET",
                    url: "/api/registration/isemailavailable?e=" + emailField.val(),
                    //data: '{"e":"' + emailField.val() + '"}',
                    processData: false,
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (data) {
                        if (data == 2) {
                            // email already registered
                            $('#emailAvailable').css("display", "inline").html("* This email is already registered with Miller, have you forgotten your password?");
                        }
                        else {
                            // user can use this email
                            $('#emailAvailable').css("display", "none");
                        }
                    },
                    error: function (request, status, error) {
                        alert("Sorry, an error occurred");
                    }
                });
            });

            $('#Button1').on('click', function () {
                var v1 = $('#tbPass1').val();
                var v2 = $('#tbPass2').val();
                if (typeof v1 !== 'undefined' && typeof v2 !== 'undefined') {
                    if (v1.length == 0) {
                        return;// didn't change pwd
                    }
                    if (v1.length > 7 && v2.length > 7 && v1 == v2) {
                        $('#mainform_details').parsley().destroy();
                    } else {
                        $('#pwdErr').show();
                        // alert("password change failed");
                    }
                }
            });
            if ($('#hasCompletedAddress').val() == 'true') {
                $('#hiddenHasAddress').val($('#hasCompletedAddress').val());
            }
        },
        validate: function ($f, $e) {
            var r = $f.parsley().validate();
            if ($f.parsley().isValid()) {
                $e.addClass('hidden');
            } else {
                $e.removeClass('hidden');
            }
            return r;
        },
        showError: function (err) {
            $('#wrongType').css('display', 'block');
            $('#wrongType').html(err);
        },
        initVacancy: function(ele, mfs, formBtn, formUi, form, updateDiv) {
            $(formBtn).on('click', function () {
                $(this).hide();
                $(formUi).show();
                $(formUi).addClass("expanded");
                forms.hookAjaxForm(form,
                    "/api/sitecore/VacancyDetail/SubmitCareersApplication",
                    updateDiv,
                    null, null, true);
            });
            $(ele).fileupload({
                replaceFileInput: false,
                dataType: 'json',
                url: '/ajax/Upload.ashx',
                add: function (e, data) {
                    $('#wrongType').css('display', 'none');
                    var valid = true;
                    var re = /^.+\.((doc)|(docx))$/i;
                    $.each(data.files, function (index, file) {
                        if (!re.test(file.name)) {
                            forms.showError('Wrong file type. Please ensure CV is Microsoft Word format.');
                            valid = false;
                        }
                        if (file.size > mfs) {
                            forms.showError('Your CV is too large to upload. Ensure that the file is < 10MB.');
                            valid = false;
                        }
                    });
                    if (valid) {
                        data.submit();
                        $('#feedback').html("Uploading....");
                        $('#Button1').prop('disabled', true);
                    }
                },
                done: function (e, data) {
                    $.each(data.result, function (key, val) {
                        if (key == 'name') {
                            if (val == "TOO_LARGE") {
                                forms.showError('Your CV is too large to upload. Ensure that the file is < 10MB.');
                            } else if (val == "ERROR") {
                                forms.showError('Sorry an error occurred while uploading. Please check your file and try again.');
                            }
                        } else if (key == 'id') {
                            $('#fileid').val(val);
                            $('#Button1').prop('disabled', false);
                        } else if (key == 'ext') {
                            $('#docExt').val(val);
                        }
                        $('#feedback').html("");
                    });
                    $('#fileid').parsley().validate();
                },
                fail: function (e, data) {
                    forms.showError('Sorry an error occurred while uploading. Please check your file/connection and try again.');
                    $('#fileid').val('');
                    $('#feedback').html("");
                }
            });

            $(form).parsley({ errorsWrapper: '<div></div>', errorTemplate: '<span></span>' });
            //show / hide elements and validations dynamically (dropdowns, other)
            $('#Ethnicity').on('change', function () {
                if ($('#Ethnicity').val() == 'Other') {
                    $('#ethSpecify').fadeIn();
                    $('#EthnicitySpecific').attr('data-parsley-required', 'true');
                } else {
                    $('#ethSpecify').hide();
                    $('#EthnicitySpecific').attr('data-parsley-required', 'false');
                }
            });
            $('#Disability').on('change', function () {
                if ($('#Disability').val() == 'Yes') {
                    $('#disSpecify').fadeIn();
                    $('#Disabilitydesc').attr('data-parsley-required', 'true');
                } else {
                    $('#disSpecify').hide();
                    $('#Disabilitydesc').attr('data-parsley-required', 'false');
                }
            });
        }
    }
})();

var customerService = (function () {
    return {
        initValidation: function (url, $submit, form, errorTop) {
            // url
            $('#aqform').parsley({ errorsWrapper: '<div></div>', errorTemplate: '<span></span>' });
            forms.hookAjaxForm(form, url, ".ModalFrameContent", ".modalSpinner", null, true);
            _ictt.push(['_autoPopulateInput', { 'id': 'InfinityVisitorId', 'item': 'ictvid' }]); // infinity tracking hack
        }
    };
})();
window.forms = forms;